import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  useEffect(() => { if (orderId) api.post(`/checkout/release/${orderId}`).catch(() => {}); }, [orderId]);
  return (
    <div className="luxy-container py-24 sm:py-32 text-center max-w-xl mx-auto">
      <p className="eyebrow mb-3">Checkout Cancelled</p>
      <h1 className="font-serif text-4xl text-pitch">Your order was not placed</h1>
      <p className="text-charcoal/70 mt-4">No payment was taken and the piece has been returned to the archive. Your bag is still saved.</p>
      <div className="flex gap-4 justify-center mt-10 flex-wrap">
        <Link to="/cart" className="bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] px-8 py-4">Return to Bag</Link>
        <Link to="/shop" className="border border-pitch text-xs font-mono uppercase tracking-[0.2em] px-8 py-4 hover:bg-pitch hover:text-ivory transition-colors">Continue Shopping</Link>
      </div>
    </div>
  );
}
